import { GetServerSideProps, NextPage } from 'next';

import MetaTags from '@/components/layout/MetaTags';
import Header from '@/components/utils/Header';
import textPagesService from '@/services/textPagesService';
import type TextPageType from '@/types/TextPageType';

import styles from '../styles/TextPage.module.scss';

interface Props {
  textPage: TextPageType;
}

export const getServerSideProps: GetServerSideProps<Props> = async () => {
  const { text_page } = await textPagesService.getTextPage('polityka-prywatnosci');

  return {
    props: {
      textPage: text_page,
    },
  };
};

const TextPage: NextPage<Props> = ({ textPage }) => {
  return (
    <div className={styles.textPage}>
      <MetaTags
        title={textPage.meta_title || textPage.title}
        description={textPage.meta_description || textPage.content}
      />
      <Header title={textPage.title} />
      <div className="container">
        <div
          className={styles.textPageContent}
          dangerouslySetInnerHTML={{ __html: textPage.content }}
        />
      </div>
    </div>
  );
};

export default TextPage;
